<template>
	<el-dialog title="自定义快捷入口" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
		<div>拖拽可调整顺序，最多添加9个快捷入口</div>
		<draggable
			v-model="list"
			:options="{ animation: 200, filter: '.no-drag, .close', preventOnFilter: false }"
			class="menuList">
			<div v-for="(item, index) in list" :key="item.name" class="item" :style="{ '--color': item.color }">
				<div class="close">
					<!-- @click.stop="removeEntry(index)" -->
					<!-- <i class="el-icon-close"></i> -->
					<el-checkbox v-model="item.checked" @change="handerChange(index, $event)"></el-checkbox>
				</div>
				<!-- <div class="icon">{{ item.icon }}</div> -->
				<img :src="`/img/menus/${item.icon}.png`" alt="图标" class="icon" />
				<div class="name">{{ item.name }}</div>
				<div class="sort">
					<i class="el-icon-rank" />
					&nbsp;拖拽排序
				</div>
			</div>
			<div v-if="list.length < 9" class="edit-item no-drag" @click="editEntries">
				<div class="icon" style="width: 100%; text-align: center; font-size: 34px">+</div>
				<div class="name">添加快捷入口</div>
			</div>
		</draggable>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
	import draggable from 'vuedraggable';
	export default {
		name: 'MenuDialog',
		components: { draggable },
		props: {
			dialogVisible: {
				type: Boolean,
				required: false,
			},
			menuList: {
				type: Array,
				required: true,
				default: () => [],
			},
		},
		watch: {
			dialogVisible(newVal) {
				if (newVal) {
					this.list = JSON.parse(JSON.stringify(this.menuList));
				} else {
					this.list = [];
				}
			},
		},
		data() {
			return {
				list: [],
			};
		},
		methods: {
			editEntries() {
				this.$message.info('编辑功能待开发');
			},
			removeEntry(index) {
				this.list.splice(index, 1);
			},
			handerChange(index, val) {
				this.list[index].checked = val;
			},
			handleSubmit() {
				this.$message.success('设置成功');
				this.$emit('updateSuccess', this.list);
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
		},
	};
</script>
<style scoped lang="scss">
	.menuList {
		width: 100%;
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
		margin: 10px 0;
		.item {
			height: 70px;
			width: calc(100% / 3 - 10px);
			text-align: center;
			border: 1px solid #f0f0f0;
			border-radius: 10px;
			padding: 12px 0;
			cursor: pointer;
			position: relative;
		}

		.close {
			border-radius: 3px;
			padding: 1px;
			position: absolute;
			top: 5px;
			right: 5px;
			font-size: 20px;
			color: #f53f3f;
		}

		.close:hover {
			background-color: rgba($color: #000000, $alpha: 0.07);
		}

		.edit-item {
			height: 70px;
			width: calc(100% / 3 - 10px);
			text-align: center;
			border: 1px dashed #ccc;
			color: #999;
			cursor: pointer;
			border-radius: 10px;
			padding: 12px 0;
		}

		.edit-item:hover {
			border-color: #409eff;
			color: #409eff;
		}

		.icon {
			width: 30px;
			height: 30px;
			font-size: 24px;
			color: var(--color);
		}

		.name {
			font-size: 14px;
			margin-top: 4px;
		}

		.sort {
			font-size: 10px;
			color: #999;
			margin-top: 2px;
		}
	}
</style>
